module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="js-navigation-region"></div>\n<div class="player-comparison-container">\n	<div class="top-content-region">\n		<div class="content-region">\n			<div class="js-board-region player-comparison-content-container"></div>\n			<div class="js-chart-region chart-region player-comparison-content-container"></div>\n		</div>\n		<div class="js-aside-region"></div>\n	</div>\n	<div class="content-region">\n		<div class="js-stats-box-region stats-box-region player-comparison-content-container"></div>\n	</div>\n</div>';
}
return __p;
};
